import { TemplateStore } from '../components/App/stores/TemplateStore';
import { AppStore } from '../components/App/stores/AppStore';
import { KurtosysApiStore } from '../components/App/stores/KurtosysApiStore';
import { TranslationStore } from '../components/App/stores/TranslationStore';
import { QueryStore } from '../components/App/stores/QueryStore';
import { MessageStore } from '../components/App/stores/MessageStore';
import { Manifest } from './Manifest';
import { UserDetailStore } from '../components/UserDetail/stores/UserDetailStore';
import { ResetPasswordStore } from '../components/ResetPassword/stores/ResetPasswordStore';
import { MfaSetupStore } from '../components/MfaSetup/stores/MfaSetupStore';
import { MfaSetupPushStore } from '../components/MfaSetupPush/stores/MfaSetupPushStore';
import { MfaSetupTextStore } from '../components/MfaSetupText/stores/MfaSetupTextStore';
import { MfaSetupCallStore } from '../components/MfaSetupCall/stores/MfaSetupCallStore';
import { PhoneNumberStore } from '../components/PhoneNumber/stores/PhoneNumberStore';
import { AssuranceStore } from '../components/Assurance/stores/AssuranceStore';
import { ImpersonationStore } from '../components/Impersonation/stores/ImpersonationStore';
/* [Component: storesImport] */

export class StoreContext {
	templateStore: TemplateStore;
	appStore: AppStore;
	kurtosysApiStore: KurtosysApiStore;
	translationStore: TranslationStore;
	queryStore: QueryStore;
	userDetailStore: UserDetailStore;
	messageStore: MessageStore;
	resetPasswordStore: ResetPasswordStore;
	mfaSetupStore: MfaSetupStore;
	mfaSetupPushStore: MfaSetupPushStore;
	mfaSetupTextStore: MfaSetupTextStore;
	mfaSetupCallStore: MfaSetupCallStore;
	phoneNumberStore: PhoneNumberStore;
	assuranceStore: AssuranceStore;
	impersonationStore: ImpersonationStore;
	/* [Component: storeVariable] */
	constructor(element: HTMLElement, url: string, templateStore: TemplateStore, public manifest: Manifest) {
		this.templateStore = templateStore;
		this.kurtosysApiStore = new KurtosysApiStore(this);
		this.translationStore = new TranslationStore(this);
		this.queryStore = new QueryStore(this);
		this.messageStore = new MessageStore(this);
		this.appStore = new AppStore(element, url, this, manifest);
		this.userDetailStore = new UserDetailStore(this);
		this.resetPasswordStore = new ResetPasswordStore(this);
		this.mfaSetupStore = new MfaSetupStore(this);
		this.mfaSetupPushStore = new MfaSetupPushStore(this);
		this.mfaSetupTextStore = new MfaSetupTextStore(this);
		this.mfaSetupCallStore = new MfaSetupCallStore(this);
		this.phoneNumberStore = new PhoneNumberStore(this);
		this.assuranceStore = new AssuranceStore(this);
		this.impersonationStore = new ImpersonationStore(this);
		/* [Component: storeAssignment] */
		this.initialize();
	}
	initialize() {
		this.appStore.initialize();
	}
	get providerProps() {
		return {
			appStore: this.appStore,
			kurtosysApiStore: this.kurtosysApiStore,
			translationStore: this.translationStore,
			messageStore: this.messageStore,
			queryStore: this.queryStore,
			userDetailStore: this.userDetailStore,
			resetPasswordStore: this.resetPasswordStore,
			mfaSetupStore: this.mfaSetupStore,
			mfaSetupPushStore: this.mfaSetupPushStore,
			mfaSetupTextStore: this.mfaSetupTextStore,
			mfaSetupCallStore: this.mfaSetupCallStore,
			phoneNumberStore: this.phoneNumberStore,
			assuranceStore: this.assuranceStore,
			impersonationStore: this.impersonationStore,
			/* [Component: storeProviderProps] */
		};
	}

	// TODO: NEED TO MERGE STORES
	registerStore(key: string, store: any) {

	}
}